import React from 'react';
import { motion } from 'framer-motion';
import { Container } from './ui/Container';
import { SectionTag } from './ui/SectionTag';
import { CTAButton } from './ui/CTAButton';
import { GuaranteeLine } from './ui/GuaranteeLine';
import { FULL_MOCKUP_URL } from '../data/images';
const easeOut: [number, number, number, number] = [0.23, 1, 0.32, 1];
export function Hero() {
  return <section id="top" className="relative overflow-hidden bg-mp-black pt-14 pb-16 md:pt-20 md:pb-24" data-id="element-176" data-mp="1297ahz3tqr77">
      <div className="pointer-events-none absolute inset-0 court-lines opacity-60" aria-hidden="true" data-id="element-177" data-mp="xanqw5cpdri0" />
      <div className="pointer-events-none absolute -top-40 right-0 h-[520px] w-[520px] rounded-full opacity-50 md:right-10" style={{
      background: 'radial-gradient(circle, rgba(8,117,209,0.35), transparent 65%)'
    }} aria-hidden="true" data-id="element-178" data-mp="saruar6c52ch" />
      <Container className="relative z-10" data-id="element-179" data-mp="3czfny6wb6l9q">
        <div className="flex flex-col items-center gap-12 md:flex-row md:items-center md:gap-8" data-id="element-180" data-mp="3825xqp13i5ku">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          ease: easeOut
        }} className="w-full md:w-[52%]" data-id="element-181" data-mp="3j898df6ywfql">
            <SectionTag tone="lime" data-id="element-182" data-mp="399jnddjryf64">Para monitores y entrenadores de pádel</SectionTag>

            <h1 className="mt-5 font-heading text-4xl font-semibold uppercase leading-[1.05] text-mp-white sm:text-5xl md:text-[3.4rem]" data-id="element-183" data-mp="3e8ei9dv0nu6l">
              Deja de improvisar clases.
              <br data-id="element-184" data-mp="3599k48nda2uy" />
              Empieza a dirigirlas <span className="text-mp-lime" data-id="element-185" data-mp="35aawqhk16xes">como un profesional</span>.
            </h1>

            <p className="mt-6 max-w-[650px] text-base leading-relaxed text-mp-gray md:text-lg" data-id="element-186" data-mp="2ql6dqy5ewp5m">
              El sistema práctico para monitores de pádel que quieren preparar mejores clases en menos tiempo,
              corregir con más criterio y conseguir que sus alumnos noten una progresión real.
            </p>

            <p className="mt-5 font-heading text-xs uppercase tracking-[0.18em] text-mp-electric md:text-sm" data-id="element-187" data-mp="2lmv16fnqg0jp">
              5 Tomos + 5 Herramientas Prácticas + 250+ Páginas
            </p>

            {/* Mobile mockup sits after subtitle/product line, before price + CTA */}
            <div className="mt-8 md:hidden" data-id="element-188" data-mp="id00cg3n7mjd">
              <HeroMockup priority data-id="element-189" data-mp="dd5eiqyq5n56" />
            </div>

            <div className="mt-8 rounded-2xl border border-mp-border bg-mp-card/60 p-5 md:mt-10 md:p-6" data-id="element-190" data-mp="deq6c8tnmrzc">
              <p className="font-heading text-lg uppercase tracking-wide text-mp-white" data-id="element-191" data-mp="1b0duk6fyi3zs">Maestro en Pista</p>
              <p className="font-heading text-sm uppercase tracking-wide text-mp-gray" data-id="element-192" data-mp="162m47guympxp">
                El Manual del Monitor de Pádel
              </p>
              <p className="mt-2 text-xs uppercase tracking-[0.15em] text-mp-gray" data-id="element-193" data-mp="x1w96fdix3l1">
                Técnica · Táctica · Metodología · Liderazgo
              </p>

              <CTAButton href="#oferta" className="mt-6 w-full" showArrow data-id="element-194" data-mp="3lqm3q21erbwi">
                Quiero mis clases listas — Acceso inmediato
              </CTAButton>

              <GuaranteeLine className="mt-4" data-id="element-195" data-mp="1xam9t2xwyd4q" />
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          ease: easeOut,
          delay: 0.1
        }} className="hidden w-full md:block md:w-[48%]" data-id="element-196" data-mp="21bxx31tbem9r">
            <HeroMockup priority data-id="element-197" data-mp="2b2k6ufecoikj" />
          </motion.div>
        </div>
      </Container>
    </section>;
}
function HeroMockup({
  priority = false
}: {
  priority?: boolean;
}) {
  return <div className="relative" data-id="element-198" data-mp="2l100oq4ri5xq">
      <div className="pointer-events-none absolute inset-0 -z-10 rounded-full opacity-70 blur-2xl" style={{
      background: 'radial-gradient(circle, rgba(8,117,209,0.4), transparent 70%)'
    }} aria-hidden="true" data-id="element-199" data-mp="2ozz3a430tqm0" />
      <img src={FULL_MOCKUP_URL} alt="Kit completo Maestro en Pista: 5 tomos, 5 bonos y Kit de Ejecución" width={800} height={800} fetchPriority={priority ? 'high' : 'auto'} loading={priority ? 'eager' : 'lazy'} className="mx-auto w-full max-w-[560px] drop-shadow-2xl" data-id="element-200" data-mp="unraoxe69lte" />
    </div>;
}